import { render } from "./IconPhoneV2.vue?vue&type=template&id=4edff13c"
import script from "./IconPhoneV2.vue?vue&type=script&lang=js"
export * from "./IconPhoneV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__